export const COMPANIES_DOMAIN = 'app/modules/Contents/COMPANIES_DOMAIN';

export const REQUEST_COMPANY = 'app/modules/Contents/REQUEST_COMPANY';
export const REQUEST_DUPLICATE_VAT_COMPANY = 'REQUEST_DUPLICATE_VAT_COMPANY';
export const REQUEST_HOME_COMPANY = 'app/modules/Contents/REQUEST_HOME_COMPANY';
export const REQUEST_COMPANY_PROPERTY = 'app/modules/Contents/REQUEST_COMPANY_PROPERTY';
export const REQUEST_COMPANIES_PROPERTY = 'app/modules/Contents/REQUEST_COMPANIES_PROPERTY';
export const REQUEST_COMPANY_USERS = 'app/modules/Contents/REQUEST_COMPANY_USERS';
export const REQUEST_COMPANIES = 'app/modules/Contents/REQUEST_COMPANIES';
export const REQUEST_COMPANIES_CREATE = 'app/modules/Contents/REQUEST_COMPANIES_CREATE';
export const REQUEST_COMPANIES_SEARCH = 'app/modules/Contents/REQUEST_COMPANIES_SEARCH';
export const REQUEST_COMPANIES_BY_IDS = 'app/modules/Contents/REQUEST_COMPANIES_BY_IDS';

export const REQUEST_COMPANY_PROPERTY_NAMES = 'app/modules/Contents/REQUEST_COMPANY_PROPERTY_NAMES';
export const REQUEST_COUNTRIES = 'app/modules/Contents/REQUEST_COUNTRIES';
export const REQUEST_COMPANY_FILTER = 'app/modules/Contents/REQUEST_COMPANY_FILTER';
export const UPDATE_COMPANY_FILTERS = 'app/modules/Contents/UPDATE_COMPANY_FILTERS';
export const UPDATE_COMPANY_SEARCH_STRING = 'app/modules/Contents/UPDATE_COMPANY_SEARCH_STRING';
export const APPLY_COMPANY_FILTER = 'app/modules/Contents/APPLY_COMPANY_FILTER';
export const REQUEST_COMPANY_FILTER_RESET = 'app/modules/Contents/REQUEST_COMPANY_FILTER_RESET';
export const APPLY_COMPANY_SORT_ORDER = 'app/modules/Contents/APPLY_COMPANY_SORT_ORDER';

export const REQUEST_COMPANY_HISTORY = 'app/modules/Contents/REQUEST_COMPANY_HISTORY';
export const UPDATE_COMPANY_HISTORY_FILTER = 'app/modules/Contents/UPDATE_COMPANY_HISTORY_FILTER';
export const UPDATE_COMPANY_HISTORY_SEARCH_STRING = 'app/modules/Contents/UPDATE_COMPANY_HISTORY_SEARCH_STRING';

export const REQUEST_COMPANY_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_COMPANY_PROPERTY_UPDATE';
export const REQUEST_COMPANY_AVATAR_UPDATE = 'app/modules/Contents/REQUEST_COMPANY_AVATAR_UPDATE';
export const REQUEST_ADD_COMPANY_ADDRESS = 'app/modules/Contents/REQUEST_ADD_COMPANY_ADDRESS';
export const REQUEST_UPDATE_COMPANY_ADDRESS = 'app/modules/Contents/REQUEST_UPDATE_COMPANY_ADDRESS';
export const REQUEST_DELETE_COMPANY_ADDRESS = 'app/modules/Contents/REQUEST_DELETE_COMPANY_ADDRESS';
export const REQUEST_ADD_COMPANY_TO_COMPANIES = 'app/modules/Contents/REQUEST_ADD_COMPANY_TO_COMPANIES';
export const REQUEST_DELETE_COMPANY_FROM_COMPANY = 'app/modules/Contents/REQUEST_DELETE_COMPANY_FROM_COMPANY';
export const REQUEST_ADD_DOCUMENT = 'app/modules/Contents/REQUEST_ADD_DOCUMENT';
export const REQUEST_DELETE_DOCUMENT = 'app/modules/Contents/REQUEST_DELETE_DOCUMENT';

export const REQUEST_COMPANY_SET_SUB_COMPANY = 'app/modules/Contents/REQUEST_COMPANY_SET_SUB_COMPANY';
export const REQUEST_COMPANY_SET_PARENT_COMPANY = 'app/modules/Contents/REQUEST_COMPANY_SET_PARENT_COMPANY';
export const REQUEST_COMPANY_DELETE_USER_FROM_COMPANY = 'app/modules/Contents/REQUEST_COMPANY_DELETE_USER_FROM_COMPANY';
export const REQUEST_COMPANY_ADD_USER = 'app/modules/Contents/REQUEST_COMPANY_ADD_USER';
export const REQUEST_COMPANY_WORKFLOWS = 'app/modules/Company/REQUEST_COMPANY_WORKFLOWS';
export const REQUEST_ADD_COMPANY_WORKFLOW = 'app/modules/Company/REQUEST_ADD_COMPANY_WORKFLOW';
export const REQUEST_REMOVE_COMPANY_WORKFLOW = 'app/modules/Company/REQUEST_REMOVE_COMPANY_WORKFLOW';
export const EXPORT_DATA = 'app/modules/Contents/EXPORT_DATA';

export const INITIATE_COMPANY_CREATE = 'app/modules/Contents/INITIATE_COMPANY_CREATE';
export const INITIATE_COMPANY_EDIT = 'app/modules/Contents/INITIATE_COMPANY_EDIT';
export const SET_NEW_COMPANY_VALUE = 'app/modules/Contents/SET_NEW_COMPANY_VALUE';
export const SET_NEW_COMPANY_ADDRESS = 'app/modules/Contents/SET_NEW_COMPANY_ADDRESS';

export const SYNC_EXACT_ID = 'app/modules/Contents/SYNC_EXACT_ID';

export const SHOW_MAIN_FORM = 'app/modules/Contents/SHOW_MAIN_FORM';
export const HIDE_MAIN_FORM = 'app/modules/Contents/HIDE_MAIN_FORM';

export const REQUEST_IBAN_CHECK = 'app/modules/Contents/REQUEST_IBAN_CHECK';
export const REQUEST_VIES_CHECK = 'app/modules/Contents/REQUEST_VIES_CHECK';
export const REQUEST_VIES_CHECK_HISTORY = 'app/modules/Contents/REQUEST_VIES_CHECK_HISTORY';
export const REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT = 'app/modules/Contents/REQUEST_DOWNLOAD_VIES_CHECK_DOCUMENT';

export const ADD_COMPANY_TO_BULK_ACTIONS_LIST = 'app/modules/Contents/ADD_COMPANY_TO_BULK_ACTIONS_LIST';
export const REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST = 'app/modules/Contents/REMOVE_COMPANY_FROM_BULK_ACTIONS_LIST';
export const REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST = 'app/modules/Contents/REMOVE_ALL_COMPANY_FROM_BULK_ACTIONS_LIST';
export const SHARE_EXCEL_COMPANY_DATA = 'app/modules/Contents/SHARE_EXCEL_COMPANY_DATA';

export const TOGGLE_NOTIFICATION = 'app/modules/Contents/TOGGLE_NOTIFICATION';

export const FILTER_DEFAULT_LIMIT = 50;

export const COMPANY_DUN = 'app/modules/Company/COMPANY_DUN';

export const COMPANY_PROPERTY_NAMES = [
  {
    name: 'name',
    type: 'string',
  },
  {
    name: 'email_address',
    type: 'email',
  },
  {
    name: ' rdwNumberisValid',
    type: 'boolean',
  },
  {
    name: 'website',
    type: 'string',
  },
  {
    name: 'phonenr_1',
    type: 'string',
  },
  {
    name: 'intl_phone_prefix',
    type: 'string',
  },
  {
    name: 'company_email_address',
    type: 'string',
  },
  {
    name: 'rdw_number',
    type: 'string',
  },
  {
    name: 'kvk_number',
    type: 'string',
  },
  {
    name: 'kvk_branch_number',
    type: 'string',
  },
  {
    name: 'iban',
    type: 'string',
  },
  {
    name: 'bic',
    type: 'string',
  },
];

export const LANGUAGES = [
  { code: 'EN', country: 'English' },
  { code: 'FR', country: 'France' },
  { code: 'DE', country: 'Germany' },
  { code: 'IT', country: 'Italy' },
  { code: 'NL', country: 'Netherlands' },
  { code: 'ES', country: 'Spain' },
];

export const BTW_COUNTRIES = [
  { code: 'AT', country: 'Austria' },
  { code: 'BE', country: 'Belgium' },
  { code: 'BG', country: 'Bulgaria' },
  { code: 'HR', country: 'Croatia' },
  { code: 'CY', country: 'Cyprus' },
  { code: 'CZ', country: 'Czech Republic' },
  { code: 'DK', country: 'Denmark' },
  { code: 'EE', country: 'Estonia' },
  { code: 'FI', country: 'Finland' },
  { code: 'FR', country: 'France' },
  { code: 'DE', country: 'Germany' },
  { code: 'EL', country: 'Greece' },
  { code: 'HU', country: 'Hungary' },
  { code: 'IE', country: 'Ireland' },
  { code: 'IT', country: 'Italy' },
  { code: 'LV', country: 'Latvia' },
  { code: 'LT', country: 'Lithuania' },
  { code: 'LU', country: 'Luxembourg' },
  { code: 'MT', country: 'Malta' },
  { code: 'NL', country: 'Netherlands' },
  { code: 'PL', country: 'Poland' },
  { code: 'PT', country: 'Portugal' },
  { code: 'RO', country: 'Romania' },
  { code: 'SK', country: 'Slovakia' },
  { code: 'SI', country: 'Slovenia' },
  { code: 'ES', country: 'Spain' },
  { code: 'SE', country: 'Sweden' },
  { code: 'UA', country: 'Ukraine' },
];

export const CREATE_REQUIRED_FIELDS_TYPE_COMPANY = ['name', 'addressLine1', 'postcode', 'city', 'countryId'];
export const CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL = [
  'name',
  'surname',
  'email',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'phone_number',
];

export const BULK_ACTION_DEFAULT_EXCEL_COMPANY_DATA = [
  'company_type',
  'name',
  'surname',
  'kvk_number',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'company_email',
  'email',
  'phone_number',
  'language',
  'accountManagerId',
  'status',
  'BTW_number',
  'customernumber',
  'company_from_eu',
];

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1 = [
  'company_type',
  'name',
  'surname',
  'kvk_number',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'company_email',
  'phone_number',
  'language',
  'incoming_block',
  'outgoing_block',
  'skip_KYC',
  'wait_for_pickup',
  'no_release_before_incoming_transport',
  'no_incoming_payment_before_transport',
  'accountManagerId',
  'vindat_relation',
  'vindat_legal_form',
  'RDW_number',
  'status',
];

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2 = [
  'invoice_to_main_address',
  'IBAN',
  'bic',
  'BTW_number',
  'currency',
  'vindat_paymenttype',
  'vindat_paymentcondition',
  'purchase_payment_term',
  'payment_term',
  'credit_limit',
  'customernumber',
  'company_from_eu',
  'has_ordered',
  'has_incoming_order',
];

export const COMPANY_QUICK_CREATE_FIELDS = [
  'company_type',
  'name',
  'surname',
  'company_email',
  'email',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'country_code',
  'phone_number',
  'language',
  'accountManagerId',
  'contact',
];

export const COMPANY_FIRST_STEP_FIELD_TYPES = [
  'name',
  'kvk_number',
  'company_email',
  'phone_number',
  'country_code',
  'company_type',
  'name',
  'surname',
  'email',
  'date_of_birth',
  'ORB_TDN_preference',
  'accountManagerId',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'RDW_number',
];

export const COMPANY_SECOND_STEP_FIELD_TYPES = [
  'IBAN',
  'invoice_to_main_address',
  'bic',
  'currency',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'company_from_eu',
];

export const COMPANY_FOURTH_STEP_FIELD_TYPES = [
  'release_before_incoming_transport',
  'release_before_outgoing_transport',
  'prefence_incoming_transport',
  'prefence_outgoing_transport',
];

export const COMPANY_DETAILS_COMPANY_DATA_CARD = [
  'name',
  'address',
  //'headquarters',
  'phone_number',
  'company_email',
  'email',
  'website',
  'company_from_eu',
  'accountManagerId',
  // 'ORB_TDN_preference',
  //'vindat_auction',
  // 'vindat_valuation_center',
  // 'in_the_wallet',
  'RDW_number',
  // 'Vindat_Relation',
  // 'Vindat_Franchisefomule',
  // 'vindat_legal_form',
  'createdAt',
];

export const COMPANY_DETAILS_COMPANY_OWNER_CARD = [
  'owner_name',
  'date_of_foundation',
  'type_ID',
  'ID_number',
  'expiration_date',
];

export const COMPANY_DETAILS_FINANCIAL_INFO_CARD = [
  'billing_address',
  'IBAN',
  'IBAN_approved',
  'IBAN_approved_manual',
  'bic',
  'BTW_number',
  'viesCheckStatus',
  'currency',
  'customernumber',
  'vindat_paymenttype',
  'no_incoming_payment_before_transport',
  'no_release_before_incoming_transport',
  'wait_for_pickup',
  'vindat_paymentcondition',
  'purchase_payment_term',
  'payment_term',
  'credit_limit',
  'finance_type',
  'kvk_number',
  'company_from_eu',
  'bordercross',
  'status',
];

export const COMPANY_VINDAT_RELATION_OPTIONS = [
  'autoherstel',
  'transport',
  'leasemaatschappij',
  'merkdealer',
  'overig',
  'taxibedrijf',
  'universeel',
  'veilinghuis',
  'overheid',
  'koeriersbedrijf',
  'detailhandel',
  'uitzendbureau',
  'particuliere_doorverkoop',
  'grossier',
  'dienstverlening',
];

export const COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS = [
  'autoCrew',
  'autofirst',
  'autoprofijt',
  'autovakmeester',
  'bosch Car Service',
  'carprof',
  'carXpert',
  'ELN',
  'vakgarage',
];

export const COMPANY_VINDAT_LEGAL_OPTIONS = [
  'aktiengesellschaft_ag',
  'otherwise',
  'besloten_vennootschap_bv',
  'commanditaire_vennootschap_cv',
  'eenmanszaak',
  'eingetragener_verein_e_v',
  'gesellschaft_mit_beschränkter_haftung_gmbh',
  'maatschap',
  'naamloze_vennootschap_nv',
  'vennootschap_onder_firma_vof',
  'private',
];

export const COMPANY_VINDAT_TRANSPORT_PURPOSE_OPTION = [
  'no_release_before_incoming_transport',
  'no_incoming_payment_before_transport',
  'wait_for_pickup',
];

export const COMPANY_CURRENCY_OPTIONS = [
  {
    name: 'euro',
    value: 'EUR',
  },
  {
    name: 'bosnian_exchangeable_mark',
    value: 'BAM',
  },
  {
    name: 'bulgarian_lev',
    value: 'BGN',
  },
  {
    name: 'croatian_kuna',
    value: 'HRK',
  },
  {
    name: 'czech_koruna',
    value: 'CZK',
  },
  {
    name: 'danish_crown',
    value: 'DKK',
  },
  {
    name: 'british_pound',
    value: 'GBP',
  },
  {
    name: 'hungarian_forint',
    value: 'HUF',
  },
  {
    name: 'macedonian_dinar',
    value: 'MKD',
  },
  {
    name: 'norwegian_crown',
    value: 'NOK',
  },
  {
    name: 'polish_zloty',
    value: 'PLN',
  },
  {
    name: 'romanian_new_leu',
    value: 'RON',
  },
  {
    name: 'serbian_denar',
    value: 'RSD',
  },
  {
    name: 'swedish_crown',
    value: 'SEK',
  },
  {
    name: 'swiss_franc',
    value: 'CHF',
  },
  {
    name: 'turkish_lira',
    value: 'TRL',
  },
  {
    name: 'us_dollar',
    value: 'USD',
  },
];

export const COMPANY_VINDAT_PAYMENTTYPE = ['Ideal', 'Bank', 'Creditcard', 'PayPal', 'automatic_collection'];

export const COMPANY_VINDAT_PAYMENTCONDITION = ['prior_to', 'by_return'];

export const KYC_EXAMPLE_REQUIRED_FIELDS = ['kvk_number', 'IBAN', 'bic'];

export const KYC_REQ_FIELDS_IN = ['kvk_number', 'trade_register_check', 'IBAN', 'bic'];
export const KYC_REQ_FIELDS_NL_IN = ['kvk_number', 'trade_register_check'];
export const KYC_REQ_FIELDS_EU_IN = ['IBAN', 'bic', 'trade_register_check'];
export const KYC_REQ_FIELDS_EU_OUT = ['trade_register_check'];
export const KYC_REQ_FIELDS_OUT = ['kvk_number', 'trade_register_check'];
export const KYC_REQ_FIELDS_OUT_IDW = ['kvk_number', 'trade_register_check'];
export const KYC_REQ_FIELDS_INDIVIDUAL_IN = ['IBAN'];
export const KYC_REQ_FIELDS_INDIVIDUAL_OUT = [];

export const KYC_REQ_DOCUMENTS_EU_IN = [
  'vies_check',
  'location',
  'credit_check',
  'iban_check',
  'overige_bescheiden',
  'website',
  'bedrijvenformulier',
];
export const KYC_REQ_DOCUMENTS_EU_OUT = [
  'vies_check',
  'location',
  'kvk',
  'btw_summary',
  'id',
  'overige_bescheiden',
  'website',
  'bedrijvenformulier',
];

// IDW document requirements
export const KYC_REQ_DOCUMENTS_EU_OUT_IDW = ['vies_check', 'location', 'kvk', 'btw_summary', 'id'];
export const KYC_REQ_DOCUMENTS_EU_IN_IDW = ['vies_check', 'location', 'credit_check', 'iban_check'];
export const KYC_REQ_DOCUMENTS_NL_IDW = ['vies_check', 'overige_bescheiden', 'website'];
export const KYC_REQ_DOCUMENTS_INDIVIDUAL_IN_IDW = ['id', 'bank_card', 'overige_bescheiden'];
export const KYC_REQ_FIELDS_IN_IDW = ['kvk_number', 'IBAN', 'bic'];
export const KYC_REQ_FIELDS_NL_IN_IDW = ['kvk_number'];
export const KYC_REQ_FIELDS_EU_IN_IDW = ['IBAN', 'bic'];
export const KYC_REQ_FIELDS_EU_OUT_IDW = [];
export const KYC_REQ_FIELDS_INDIVIDUAL_IN_IDW = ['IBAN'];
export const KYC_REQ_FIELDS_INDIVIDUAL_OUT_IDW = [];
export const KYC_REQ_DOCUMENTS_NON_EU_IN_IDW = ['vies_check', 'location', 'credit_check', 'iban_check'];
export const KYC_REQ_DOCUMENTS_NON_EU_OUT_IDW = ['location', 'credit_check', 'iban_check'];

export const KYC_REQ_DOCUMENTS_NON_EU_IN = [
  'vies_check',
  'location',
  'credit_check',
  'iban_check',
  'overige_bescheiden',
  'website',
  'bedrijvenformulier',
];
export const KYC_REQ_DOCUMENTS_NON_EU_OUT = [
  'location',
  'credit_check',
  'iban_check',
  'overige_bescheiden',
  'website',
  'bedrijvenformulier',
];
export const KYC_REQ_DOCUMENTS_NL = ['vies_check', 'overige_bescheiden', 'website'];
export const KYC_REQ_DOCUMENTS_INDIVIDUAL_IN = ['id', 'bank_card', 'overige_bescheiden'];

export const KYC_EXAMPLE_REQUIRED_DOCUMENTS = [
  'vies_check',
  'location',
  'kvk',
  'btw_summary',
  'id',
  'credit_check',
  'bank_card',
];

// WIENTJES REQ FIELDS KANBANS

export const WIENTJES_COMPANY_KANBAN_FIELDS = [
  'company_type',
  'name',
  'surname',
  'company_email',
  'email',
  'addressLine1',
  'postcode',
  'city',
  'countryId',
  'country_code',
  'phone_number',
  // 'BTW_number',
  // 'accountManagerId',
  // 'contact',
];

export const WIENTJES_ADDITIONAL_FIELDS_EU_OUT = [
  'BTW_number',
  'trade_register_check',
  'accountManagerId',
  'relation_financial_contact_id',
];

export const WIENTJES_ADDITIONAL_FIELDS_NON_EU_OUT = ['bordercross'];

export const WIENTJES_EU_OUT_DOCUMENTS = [
  'vies_check',
  'kvk',
  'btw_summary',
  'iban_check',
  'id',
  // 'BewijsAuto',
  // 'Wientjes',
  //'auto_wientjes_bedrijvenformulier',
  'bedrijvenformulier',
  'schermafdruk_vies_adres',
  'website',
  //'schermafdruk_verkoop_website',
  'overig',
];
export const WIENTJES_NON_EU_OUT_DOCUMENTS = ['OFAC', 'id'];
export const WIENTJES_NEW_FIELDS_EU_OUT = ['owner_name', 'date_of_foundation', 'type_ID', 'ID_number', 'expiration_date'];

export const COMMERCIAL_DEFAULTS_USER_IDS = [33, 25, 38, 20, 49, 28, 16, 32, 17, 26, 9, 30, 15, 44];
